import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-dropdown', 'openLang', 'Atvērt valodas maiņas izvēlni');
Labels.set('ui-dropdown', 'countryCode', 'Valsts kods');
Labels.set('ui-dropdown', 'listboxName', 'Pieejamie varianti');

Labels.set('ui-dropdown', 'eng', 'Angļu');
Labels.set('ui-dropdown', 'lat', 'Latviešu');
Labels.set('ui-dropdown', 'rus', 'Krievu');
